import { Layers } from "../camera-layers";

// XR input models load asynchronously, so refresh their descendants each frame.
// Do not enable the entire UI layer: that would reveal unrelated scene menus.
export function updateXRInputLayers(xr, immersive) {
  if (!xr) return;
  const action = immersive ? "enable" : "disable";
  const update = object => object.layers[action](Layers.CAMERA_LAYER_INSPECT);
  for (let index = 0; index < 2; index++) {
    xr.getControllerGrip(index).traverse(update);
    xr.getHand(index).traverse(update);
  }
}
